import { NgModule } from '@angular/core';
import { FixedSizeCollectionVirtualScroll } from './collection-fixed-size-virtual-scroll';
import { CollectionScrollable } from './collection-scrollable';
import { CollectionVirtualForOf } from './collection-virtual-for-of';
import { CollectionVirtualScrollViewport } from './collection-virtual-scroll-viewport.component';

@NgModule({
  declarations: [CollectionScrollable],
  exports: [CollectionScrollable]
})
export class CollectionScrollableModule {}

@NgModule({
  imports: [CollectionScrollableModule],
  exports: [
    CollectionScrollableModule,
    FixedSizeCollectionVirtualScroll,
    CollectionVirtualForOf,
    CollectionVirtualScrollViewport
  ],
  declarations: [FixedSizeCollectionVirtualScroll, CollectionVirtualForOf, CollectionVirtualScrollViewport]
})
export class CollectionVirtualScrollingModule {}
